import Grid from "@material-ui/core/Grid";
import { makeStyles } from "@material-ui/core/styles";
import Tooltip from "@material-ui/core/Tooltip";
import Typography from "@material-ui/core/Typography";
import moment from "moment";
import React from "react";
import ProgressiveImage from "react-progressive-image";
import { useNavigate } from "react-router-dom";
import productDefaultImg from "../../../assets/images/defaultImages/imageUpload-img.jpg";
import itemInfoStyles from "../../../assets/styles/components/itemInfoStyles";
import BreadCrumps from "../../../components/BreadCrups";
import Tag from "../../../components/tag";
import { Markup } from "interweave";
import SingleItemMenu from "../../../components/Menu/SingleItemMenu";
import NoContent from "../../../components/NoContent";

const styles = makeStyles((theme) => itemInfoStyles(theme));

export default (props) => {
	const { product, crumps } = props;
	const navigate = useNavigate();
	const classes = styles();

	const goToPage = (url) => navigate(url);

	return (
		<div>
			<BreadCrumps crumps={crumps} />
			{product.title ? (
				<>
					<Grid container className={classes.topSection}>
						<Grid item xs={12} container>
							<div>
								<ProgressiveImage
									src={product.imageUrl}
									placeholder={props.placeholder || productDefaultImg}
								>
									{(src, loading) => (
										<img
											style={{
												opacity: loading ? 0.7 : 1,
												objectFit: "cover",
												borderRadius: "6px",
											}}
											src={src}
											alt="No cover"
											className={classes.image}
										/>
									)}
								</ProgressiveImage>
							</div>
						</Grid>
						<Grid
							item
							xs={12}
							container
							direction="column"
							spacing={2}
							className={classes.infoSection}
						>
							<Grid item className={classes.textInfo}>
								<Grid item className={classes.actions}>
									<Grid container spacing={2} justifyContent="flex-end">
										<SingleItemMenu
											horiz
											background
											menu={props.actions}
											item={product}
										/>
									</Grid>
								</Grid>

								<Tooltip title="Author" placement="right-end" arrow>
									<Typography variant="subtitle1" className={classes.name}>
										<span style={{ color: "black" }}>Modified By:</span>{" "}
										{product.author?.name || "Unknown"}
									</Typography>
								</Tooltip>
								<Typography variant="body1" className={classes.texts}>
									Last Modified: {moment(product.createdAt).fromNow()}
								</Typography>
								<Typography variant="body1" className={classes.texts}>
									Status: {product.status}
								</Typography>
							</Grid>
						</Grid>
					</Grid>

					<Grid container className={classes.otherSections} direction="column">
						<Grid item>
							<Typography variant="subtitle1" className={classes.title}>
								Title: {product.title}
							</Typography>
						</Grid>
						<br />
						<Grid item>
							<Typography variant="subtitle1" className={classes.title}>
								Summary
							</Typography>
						</Grid>

						<Grid
							item
							style={{
								width: "100%",
								wordWrap: "break-word",
							}}
						>
							<Typography variant="subtitle2">{product.summary}</Typography>
						</Grid>

						<br />
						<Grid item>
							<Typography variant="subtitle1" className={classes.title}>
								Product Benefits
							</Typography>
						</Grid>

						<Grid
							item
							style={{
								width: "100%",
								wordWrap: "break-word",
							}}
						>
							{product.benefits.map((elt) => (
								<Typography variant="subtitle2">#{elt}</Typography>
							))}
						</Grid>

						<br />
						<Grid item>
							<Typography variant="subtitle1" className={classes.title}>
								Product Requirements
							</Typography>
						</Grid>

						<Grid
							item
							style={{
								width: "100%",
								wordWrap: "break-word",
							}}
						>
							{product.requirements.map((elt) => (
								<Typography variant="subtitle2">#{elt}</Typography>
							))}
						</Grid>
					</Grid>

					<Grid container className={classes.otherSections} direction="column">
						<div className={classes.title}>
							<Typography variant="subtitle1" className={classes.title}>
								Content
							</Typography>
						</div>

						<div className={classes.title}>
							<Markup content={product.content} />
						</div>
					</Grid>
				</>
			) : (
				<NoContent title="Unable to find product" />
			)}
		</div>
	);
};
